module.exports = __webpack_public_path__ + "static/media/DiamondBackground.b0be3c3c.png";